import React, { useEffect, useState } from 'react';
import { Button, Box, Tooltip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormGroup, Grid, IconButton } from '@mui/material'
import DashboardContainer from '../../components/DashboardContainer';
import PageContainer from '../../components/PageContainer';
import { useSnackbar } from 'notistack';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getList } from '../../redux/api/system';
import CustomDataGrid from '../../components/CustomDataGrid';

const AuditLog = () => {
  const [ processing, setProcessing ] = useState(false);
  const [ records, setRecords ] = useState([]);
  const [ eventContent, setEventContent ] = useState("");
  const [ openModal, setOpenModal ] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const columns = [
    { 
      field: 'sn', headerName: 'S/N', width: 100, sortable: false,
      renderCell: (params) => (
          <p
              style={{ margin: 'auto' }}
          >
              {params?.row?.sn}
          </p>
      )
    },
    {
      headerName: 'Actions',
      width: 70,
      renderCell: (params, rows) => (
        <Box>
           <Tooltip title="View Full Event Description" arrow>
            <IconButton
              color="primary"
              onClick={() => {setEventContent(params?.row?.event); setOpenModal(true);}}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </Box>
      )
    },
    { field: 'userID', headerName: "User ID", width: 200 },
    { field: "userRole", headerName: "User Role", width: 300 },
    { field: "institution", headerName: "Institution", width: 350 },
    { field: "eventTime", headerName: "Event Time", width: 350 },
    { field: "event", headerName: "Event", width: 450 },
    { field: "data", headerName: "Data", width: 200 },
    { field: "module", headerName: "Module", width: 150 },
    { field: "classification", headerName: "Classification", width: 200 }
  ];

  const generateRandom = () => {
    var length = 8,
        charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  };

  const init = async () => {
    try {
      setProcessing(true)
      const resp = await getList("audit_logs");
      //const response = await getList("datasets");

      //console.log(resp);

      if(resp?.responseCode === "00") {
          setRecords(resp?.listing || [])
          //setDatasets(response?.listing || [])
      } else {
          enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
      }
    }
    catch (err) {
      enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' });
    }
    finally {
      setProcessing(false);
    }
  };

  useEffect(() => {
    init()
  }, []);

  return (
    <PageContainer pageTitle="Audit Trail" processing={processing}>
      <section className="inner-banner parallax-section">
          <div className='overlay'>
              <div className="container">
                  <div className="row">
                      <div className="col-md-12 col-sm-12">
                          <h3 className="wow bounceIn" data-wow-delay="0.9s">All</h3>
                          <h1 className="wow fadeInUp text-uppercase conference mb-05 mt-05" data-wow-delay="1.6s">Audit Logs</h1>
                      </div>
                  </div>
              </div>
          </div>
      </section>
      <div className="services-area section-padding pt-3">
        <div className="container">
          <div style={{ height: '80vh', width: '100%', marginTop: '30px' }}>
            <CustomDataGrid
              columns={columns}
              rows={records}
            />
          </div>
        </div>
      </div>
      <Dialog open={openModal}>
        <DialogContent>
          <h5>Full Event Log</h5>
          <p>{eventContent}</p>
        </DialogContent>
        <DialogActions>
          <Button type="button" variant="contained" onClick={() => setOpenModal(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </PageContainer>
  )
};

export default AuditLog;